import { Box, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { useGrowers } from '../hooks/use-growers';
import { useFields } from '../hooks/use-fields';
import { useUrlUpdater } from '../hooks/use-url-updater';
import { SendToDeereProvider } from '../components/deere/send-to-deere-context';
import { SendToDeereDialog } from '../components/deere/SendToDeereDialog';
import { RunRxProvider } from './run-rx/context.jsx';
import { RunRxDialog } from './run-rx/RunRxDialog.jsx';
import { Spinner } from '../components/Spinner.jsx';

export function Section(props) {
  const params = useParams();
  const { allFields, selectedAaids, autoSelectField } = useFields();
  const {
    all: allGrowers,
    selectGrower,
    selectedId: selectedGrowerId,
  } = useGrowers();
  const { updateParams } = useUrlUpdater();

  useEffect(() => {
    if (allGrowers?.length && !selectedGrowerId && params.growerid) {
      selectGrower(params.growerid);
    }
  }, [allGrowers, params.growerid, selectGrower, selectedGrowerId]);

  useEffect(() => {
    if (!allFields?.length) return;
    if (params.aaid) autoSelectField(params.aaid);
    if (!params.aaid && selectedAaids.length === 1) {
      updateParams({ aaid: selectedAaids[0] });
    }
  }, [allFields, autoSelectField, params.aaid, selectedAaids, updateParams]);

  if (!selectedGrowerId && params.growerid) return <Spinner />;

  if (!selectedGrowerId && !params.growerid) {
    return (
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          textAlign: 'center',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="h2">Select Operation!</Typography>
        <Typography variant="h5" sx={{ mt: 2 }}>
          Select the Operation you want to continue.
        </Typography>
      </Box>
    );
  }

  return (
    <RunRxProvider>
      <SendToDeereProvider>
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
          {props.children}
        </Box>
        <RunRxDialog />
        <SendToDeereDialog />
      </SendToDeereProvider>
    </RunRxProvider>
  );
}
